import React from "react";
import PropTypes from "prop-types";
import {
	Modal,
	Button
} from "rhombus-react";

import './SkipModal.css';

export default function SkipModal({
	file,
	message,
	onSkip,
	commonModalProps,
	navigationActions: { popModal },
}){
	let { className, onClose } = commonModalProps;

	function Body(){
		return (
			<div className="message">
				{message}
			</div>
		);
	}

	function Footer(){
		return (
			<>
				<Button theme="grey" onClick={onClose}>Cancel</Button>
				<Button onClick={() => { popModal(); onSkip(); }}>Skip Adding This Creative</Button>
			</>
		);
	}

	return (
		<Modal
			{...commonModalProps}
			renderContent = { Body }
			renderFooter = { Footer }
			className = {`${className} skip-modal`}
			title = {`Upload Error - ${file.name}`}
		/>
	);
}

SkipModal.displayName = "SkipModal";

SkipModal.propTypes = {
	file: PropTypes.instanceOf(File),
	message: PropTypes.string,
	onSkip: PropTypes.func,

	commonModalProps: PropTypes.object,
	navigationActions: PropTypes.object,
};
